import DailyCountChartCard from '@components/dashboard/DailyCountChartCard';
import { useStatistics } from '@hooks/statistics';
import { BACKGROUND_COLORS, CHART_MISC_COLORS, CHART_MISC_LABELS } from '@pages/Dashboard';
import { Card } from 'antd';
import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import ClipLoader from 'react-spinners/ClipLoader';
import '../../pages/Dashboard.scss';

export const ServiceBasicStatisticsTab: React.FC = () => {
  const {
    statisticsStore,
    isLoadingDauCounts,
    isLoadingMauCounts,
    isLoadingVisitCounts,
    isLoadingNewParentsCounts,
    isLoadingNewTutorsCounts,
    isLoadingNewSellersCounts,
    isLoadingNewInstructorsCounts,
    isLoadingDau,
    isLoadingDailyJoin,
    isLoadingDailyView,
    isLoadingDailySession,
    isLoadinUserCountByState,
  } = useStatistics('overview');
  const dauDiff = (statisticsStore.countsDau?.dau || 0) - (statisticsStore.countsDau?.samePastPeriod?.dau || 0);
  const mauDiff = (statisticsStore.countsMau?.mau || 0) - (statisticsStore.countsMau?.samePastPeriod?.mau || 0);

  const vistsDiff =
    (statisticsStore.countsVisit?.visits || 0) - (statisticsStore.countsVisit?.samePastPeriod?.visits || 0);

  const newParentsDiff =
    (statisticsStore.countsNewParents?.newParentUsers || 0) -
    (statisticsStore.countsNewParents?.samePastPeriod?.newParentUsers || 0);

  const newTutorsDiff =
    (statisticsStore.countsNewTutors?.newTutorUsers || 0) -
    (statisticsStore.countsNewTutors?.samePastPeriod?.newTutorUsers || 0);

  const newSellersDiff =
    (statisticsStore.countsNewSellers?.newSellerUsers || 0) -
    (statisticsStore.countsNewSellers?.samePastPeriod?.newSellerUsers || 0);

  const newInstructorsDiff =
    (statisticsStore.countsNewInstructors?.newInstructorUsers || 0) -
    (statisticsStore.countsNewInstructors?.samePastPeriod?.newInstructorUsers || 0);

  const userCountByState = {
    labels: (statisticsStore.userCountByState || []).map((item) => item.state),
    datasets: [
      {
        data: (statisticsStore.userCountByState || []).map((item) => item.count),
        borderWidth: 1,
        backgroundColor: BACKGROUND_COLORS,
      },
    ],
  };

  const dauData = {
    labels: (statisticsStore.dau || []).map((item) => `${item._id.year}-${item._id.month}-${item._id.day}`),
    datasets: [
      {
        label: CHART_MISC_LABELS.user,
        borderColor: CHART_MISC_COLORS.user,
        backgroundColor: CHART_MISC_COLORS.user,
        data: (statisticsStore.dau || []).map((item) => item.count),
      },
    ],
  };

  const dailyJoinData = {
    labels: (statisticsStore.dailyJoin || []).map((item) => `${item._id.year}-${item._id.month}-${item._id.day}`),
    datasets: [
      {
        label: '일별 부모 가입',
        data: (statisticsStore.dailyJoin || []).map((item) => item.count),
      },
    ],
  };

  const dailyViewData = {
    labels: (statisticsStore.dailyView || []).map((item) => `${item._id.year}-${item._id.month}-${item._id.day}`),
    datasets: [
      {
        label: CHART_MISC_LABELS.view,
        borderColor: CHART_MISC_COLORS.view,
        backgroundColor: CHART_MISC_COLORS.view,
        data: (statisticsStore.dailyView || []).map((item) => item.count),
        // borderWidth: 1,
      },
    ],
  };

  const dailySessionData = {
    labels: (statisticsStore.dailySession || []).map((item) => `${item._id.year}-${item._id.month}-${item._id.day}`),
    datasets: [
      {
        label: CHART_MISC_LABELS.session,
        borderColor: CHART_MISC_COLORS.session,
        backgroundColor: CHART_MISC_COLORS.session,
        data: (statisticsStore.dailySession || []).map((item) => item.count),
      },
    ],
  };

  return (
    <div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '12px' }}>
        <div style={{ display: 'flex' }}>
          <div className="badge" style={{ color: '#242424', width: '48px', fontWeight: 'bold', flexShrink: 0 }}>
            클래스
          </div>
          <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '4px' }}>
            <div className="badge" style={{ backgroundColor: '#424242' }}>
              전체 | {statisticsStore.productCounts?.class.total}
            </div>
            <div className="badge" style={{ backgroundColor: '#3fb547' }}>
              판매중 | {statisticsStore.productCounts?.class.open}({statisticsStore.productCounts?.class?.display?.open}
              )
            </div>
            <div className="badge" style={{ backgroundColor: '#6e6e6e' }}>
              판매종료 | {statisticsStore.productCounts?.class?.close}(
              {statisticsStore.productCounts?.class?.display?.close})
            </div>
            <div className="badge" style={{ backgroundColor: '#d7aefb' }}>
              프라이빗 | {statisticsStore.productCounts?.class?.private}
            </div>
            <div className="badge" style={{ backgroundColor: '#db9737' }}>
              승인요청 | {statisticsStore.productCounts?.class?.requested}
            </div>
            <div className="badge" style={{ backgroundColor: '#d944db' }}>
              승인완료 | {statisticsStore.productCounts?.commerce.accepted}
            </div>
            <div className="badge" style={{ backgroundColor: '#bd334a' }}>
              승인반려 | {statisticsStore.productCounts?.class?.denied}
            </div>
            <div className="badge" style={{ backgroundColor: '#2782b3' }}>
              수정중 | {statisticsStore.productCounts?.class.edit}
            </div>
            <div className="badge" style={{ backgroundColor: '#6e6e6e' }}>
              삭제됨 | {statisticsStore.productCounts?.class?.deleted}
            </div>
          </div>
        </div>

        <div style={{ display: 'flex' }}>
          <div className="badge" style={{ color: '#242424', width: '48px', fontWeight: 'bold', flexShrink: 0 }}>
            커머스
          </div>
          <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '4px' }}>
            <div className="badge" style={{ backgroundColor: '#424242' }}>
              전체 | {statisticsStore.productCounts?.commerce.total}
            </div>
            <div className="badge" style={{ backgroundColor: '#3fb547' }}>
              판매중 | {statisticsStore.productCounts?.commerce.open}(
              {statisticsStore.productCounts?.commerce?.display?.open})
            </div>
            <div className="badge" style={{ backgroundColor: '#6e6e6e' }}>
              판매종료 | {statisticsStore.productCounts?.commerce?.close}(
              {statisticsStore.productCounts?.commerce?.display?.close})
            </div>
            <div className="badge" style={{ backgroundColor: '#d7aefb' }}>
              프라이빗 | {statisticsStore.productCounts?.commerce?.private}
            </div>
            <div className="badge" style={{ backgroundColor: '#db9737' }}>
              승인요청 | {statisticsStore.productCounts?.commerce?.requested}
            </div>
            <div className="badge" style={{ backgroundColor: '#d944db' }}>
              승인완료 | {statisticsStore.productCounts?.commerce.accepted}
            </div>
            <div className="badge" style={{ backgroundColor: '#bd334a' }}>
              승인반려 | {statisticsStore.productCounts?.commerce?.denied}
            </div>
            <div className="badge" style={{ backgroundColor: '#2782b3' }}>
              수정중 | {statisticsStore.productCounts?.commerce.edit}
            </div>
            <div className="badge" style={{ backgroundColor: '#6e6e6e' }}>
              삭제됨 | {statisticsStore.productCounts?.commerce?.deleted}
            </div>
          </div>
        </div>

        <div style={{ display: 'flex' }}>
          <div className="badge" style={{ color: '#242424', width: '48px', fontWeight: 'bold', flexShrink: 0 }}>
            유저
          </div>
          <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '4px' }}>
            <div className="badge" style={{ backgroundColor: '#3fb547' }}>
              부모 | {statisticsStore.countsUser?.parent}
            </div>
            <div className="badge" style={{ backgroundColor: '#2782b3' }}>
              클래스 파트너 | {statisticsStore.countsUser?.tutor}
            </div>
            <div className="badge" style={{ backgroundColor: '#d944db' }}>
              커머스 파트너 | {statisticsStore.countsUser?.seller}
            </div>
            <div className="badge" style={{ backgroundColor: '#424242' }}>
              에디터 | {statisticsStore.countsUser?.editor}
            </div>
            <div className="badge" style={{ backgroundColor: '#424242' }}>
              강사 파트너 | {statisticsStore.countsUser?.instructor}
            </div>
            <div className="badge" style={{ backgroundColor: '#424242' }}>
              어드민 | {statisticsStore.countsUser?.admin}
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
          gap: '8px',
          marginBottom: '12px',
          flexWrap: 'wrap',
        }}>
        <div
          style={{
            width: '644px',
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
          }}>
          <div style={{ display: 'flex', flexDirection: 'row', gap: '12px' }}>
            <div className="count-card" style={{}}>
              <div className="count-title">최근 24시간 방문자수</div>
              {isLoadingDauCounts && <ClipLoader />}
              {!isLoadingDauCounts && (
                <div className="count-number">
                  {`${statisticsStore.countsDau?.dau}`}
                  <span className="count-suffix" style={{ color: dauDiff > 0 ? 'green' : 'red' }}>{`${Math.round(
                    (dauDiff / (statisticsStore.countsDau?.dau || 1)) * 100,
                  )}%`}</span>
                </div>
              )}
            </div>
            <div className="count-card" style={{}}>
              <div className="count-title">최근 30일 방문자수</div>
              {isLoadingMauCounts && <ClipLoader />}
              {!isLoadingMauCounts && (
                <div className="count-number">
                  {`${statisticsStore.countsMau?.mau}`}
                  <span className="count-suffix" style={{ color: mauDiff > 0 ? 'green' : 'red' }}>{`${Math.round(
                    (mauDiff / (statisticsStore.countsMau?.mau || 1)) * 100,
                  )}%`}</span>
                </div>
              )}
            </div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'row', gap: '12px' }}>
            <div className="count-card" style={{}}>
              <div className="count-title">방문자수(기간)</div>
              {isLoadingVisitCounts && <ClipLoader />}
              {!isLoadingVisitCounts && (
                <div className="count-number">
                  {`${statisticsStore.countsVisit?.visits}`}
                  <span className="count-suffix" style={{ color: vistsDiff > 0 ? 'green' : 'red' }}>{`${Math.round(
                    (vistsDiff / (statisticsStore.countsVisit?.visits || 1)) * 100,
                  )}%`}</span>
                </div>
              )}
            </div>
            <div className="count-card" style={{}}>
              <div className="count-title">부모 가입(기간)</div>
              {isLoadingNewParentsCounts && <ClipLoader />}
              {!isLoadingNewParentsCounts && (
                <div className="count-number">
                  {`${statisticsStore.countsNewParents?.newParentUsers}`}
                  <span className="count-suffix" style={{ color: newParentsDiff > 0 ? 'green' : 'red' }}>{`${Math.round(
                    (newParentsDiff / (statisticsStore.countsNewParents?.newParentUsers || 1)) * 100,
                  )}%`}</span>
                </div>
              )}
            </div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'row', gap: '12px' }}>
            <div className="count-card">
              <div className="count-title">클래스 파트너 가입(기간)</div>
              {isLoadingNewTutorsCounts && <ClipLoader />}
              {!isLoadingNewTutorsCounts && (
                <div className="count-number">
                  {`${statisticsStore.countsNewTutors?.newTutorUsers}`}
                  <span className="count-suffix" style={{ color: newTutorsDiff > 0 ? 'green' : 'red' }}>{`${Math.round(
                    (newTutorsDiff / (statisticsStore.countsNewTutors?.newTutorUsers || 1)) * 100,
                  )}%`}</span>
                </div>
              )}
            </div>
            <div className="count-card">
              <div className="count-title">커머스 파트너 가입(기간)</div>
              {isLoadingNewSellersCounts && <ClipLoader />}
              {!isLoadingNewSellersCounts && (
                <div className="count-number">
                  {`${statisticsStore.countsNewSellers?.newSellerUsers}`}
                  <span className="count-suffix" style={{ color: newSellersDiff > 0 ? 'green' : 'red' }}>{`${Math.round(
                    (newSellersDiff / (statisticsStore.countsNewSellers?.newSellerUsers || 1)) * 100,
                  )}%`}</span>
                </div>
              )}
            </div>
            <div className="count-card">
              <div className="count-title">강사 파트너 가입(기간)</div>
              {isLoadingNewInstructorsCounts && <ClipLoader />}
              {!isLoadingNewInstructorsCounts && (
                <div className="count-number">
                  {`${statisticsStore.countsNewInstructors?.newInstructorUsers}`}
                  <span
                    className="count-suffix"
                    style={{ color: newInstructorsDiff > 0 ? 'green' : 'red' }}>{`${Math.round(
                    (newInstructorsDiff / (statisticsStore.countsNewInstructors?.newInstructorUsers || 1)) * 100,
                  )}%`}</span>
                </div>
              )}
            </div>
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            gap: '12px',
            flexWrap: 'wrap',
            flex: 1,
            justifyContent: 'flex-end',
          }}>
          <DailyCountChartCard
            title="DAU"
            countColumnTitle="DAU"
            fileNamePrefix="igogo-dau"
            isLoading={isLoadingDau}
            chartData={dauData}
            items={statisticsStore.dau}
            startDate={statisticsStore.startDate}
            endDate={statisticsStore.endDate}
          />
          <Card className="donut-chart" title="지역별 부모 가입자 수" bordered={false}>
            {isLoadinUserCountByState && <ClipLoader />}
            {!isLoadinUserCountByState && <Doughnut data={userCountByState} />}
          </Card>
        </div>
      </div>
      <div>
        <div
          style={{
            display: 'flex',
            gap: '12px',
            flexWrap: 'wrap',
            marginBottom: '12px',
          }}>
          <DailyCountChartCard
            title="일별 부모 가입자 수"
            countColumnTitle="가입자 수"
            fileNamePrefix="igogo-daily-parent-join"
            isLoading={isLoadingDailyJoin}
            chartData={dailyJoinData}
            items={statisticsStore.dailyJoin}
            startDate={statisticsStore.startDate}
            endDate={statisticsStore.endDate}
          />
          <DailyCountChartCard
            title="일별 세션 수"
            countColumnTitle="세션 수"
            fileNamePrefix="igogo-daily-session"
            isLoading={isLoadingDailySession}
            chartData={dailySessionData}
            items={statisticsStore.dailySession}
            startDate={statisticsStore.startDate}
            endDate={statisticsStore.endDate}
          />
          <DailyCountChartCard
            title="일별 뷰 수"
            countColumnTitle="뷰 수"
            fileNamePrefix="igogo-daily-view"
            isLoading={isLoadingDailyView}
            chartData={dailyViewData}
            items={statisticsStore.dailyView}
            startDate={statisticsStore.startDate}
            endDate={statisticsStore.endDate}
          />
        </div>
      </div>
    </div>
  );
};

export default ServiceBasicStatisticsTab;
